
import { Options, Vue } from 'vue-class-component';
import * as OM from '@/model';
import { Prop, Watch } from 'vue-property-decorator';

@Options({})
export default class menuLink extends Vue {

    @Prop() moduleConfig: OM.FrontendModuleConfig;

}
